import { ParameterConfirmation } from "@/pages/UserHub/GenieSetup/components/ParameterConfirmation";
import { MOCK_GENIE_DATA } from "@/types/shared/mock-data";

const ConfirmationPageDev = () => {
  const handleConfirm = (updatedAnalysis: any) => {
    console.log("✅ Confirm clicked");
    console.log("Updated Analysis:", updatedAnalysis);
  };

  const handleCancel = () => {
    console.log("❌ Cancel clicked");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ParameterConfirmation analysis={MOCK_GENIE_DATA} onConfirm={handleConfirm} onCancel={handleCancel} isCreating={false} />
    </div>
  );
};

export default ConfirmationPageDev;
